import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import { Loader2 } from "lucide-react";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import ProjectView from "@/pages/ProjectView";
import DwellingView from "@/pages/DwellingView";
import RoomView from "@/pages/RoomView";
import ValidationPage from "@/pages/ValidationPage";
import ExportPage from "@/pages/ExportPage";
import DiagnosticsPage from "@/pages/DiagnosticsPage";

const RequireAuth: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }
  if (user === null) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
          <Route path="/projects/:id" element={<RequireAuth><ProjectView /></RequireAuth>} />
          <Route path="/dwellings/:id" element={<RequireAuth><DwellingView /></RequireAuth>} />
          <Route path="/rooms/:id" element={<RequireAuth><RoomView /></RequireAuth>} />
          <Route path="/validation/:dwellingId" element={<RequireAuth><ValidationPage /></RequireAuth>} />
          <Route path="/export/:dwellingId" element={<RequireAuth><ExportPage /></RequireAuth>} />
          <Route path="/diagnostics" element={<RequireAuth><DiagnosticsPage /></RequireAuth>} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" theme="dark" richColors />
    </AuthProvider>
  );
}

export default App;
